import React, { useEffect, useState } from "react";
import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  FlatList,
} from "react-native";
//import FastImage from 'react-native-fast-image';
import { SvgUri } from "react-native-svg";
import { globalFontStyle } from "../../../assets";
import Colors from "../../../assets/Color/Colors";

const ClubImageCard = ({ isForm, title, titleImg }) => {
  return (
    <View style={{ flexDirection: "row", alignItems: "center" }}>
      <View style={[styles.marketImgStyle, { backgroundColor: Colors.grey5 }]}>
        <SvgUri width="50" height="50" uri={titleImg} />
      </View>

      <Text
        style={[
          globalFontStyle.appFontSubHeading,
          { color: Colors.black, alignSelf: "center", paddingLeft: 30 },
        ]}
      >
        {title}
      </Text>
    </View>
  );
};

export default ClubImageCard;

const styles = StyleSheet.create({
  marketImgStyle: {
    width: 35,
    height: 35,
  },
});
